import { useTranslation } from 'react-i18next'
import { Col, Row } from 'antd'

import B2BecLink from '@/components/B2BLink'
import { useAppSelector } from '@/store/hook'
import { selectIsLoggedIn } from '@/store/slices/authenticationSlice'
import usePermission from '@/hooks/usePermission'
import { MODULE_SERVICE_RIGHTS } from '@/libs/constants/modulerights'
import { parseHtml } from '@/libs/utils/common'
import SSLIcon from '@/assets/img/SSL.png'

import styles from './Footer.module.scss'

const currentYear = new Date().getFullYear()

function Footer() {
  const { t } = useTranslation()
  const isLoggedIn = useAppSelector(selectIsLoggedIn)

  const { hasPermission } = usePermission(
    MODULE_SERVICE_RIGHTS.VIEW_CONTACT_FORM,
  )

  const rawServiceInformation = t('footer.serviceInformation')
  const hotlineOnly = rawServiceInformation.split(/<br\s*\/?>/i)[0]
  const parsedServiceInformation = isLoggedIn && hasPermission
    ? parseHtml(rawServiceInformation)
    : parseHtml(hotlineOnly)

  return (
    <footer className={styles.container}>
      <div className="container">
        <div className={styles['business-workspace']}>
          <span>{t('welcome')}</span>
          <span>{t('welcome-subtext')}</span>
          <div className="full-width-page-component__wrapper mt-2 border-b-[1px] border-solid border-[#dcdcdc]" />
        </div>
        <Row className={`${styles.top__wrapper}`}>
          <Col
            className={styles.col_wrapper}
            lg={{ span: 7, offset: 2, order: 0 }}
            md={{ span: 8, offset: 0, order: 0 }}
            sm={12}
            xl={{ span: 7, offset: 2, order: 0 }}
            xs={24}
          >
            <h3>{t('footer.contact')}</h3>
            <p>{t('footer.contactAddress')}</p>
          </Col>
          <Col
            className={styles.col_wrapper}
            lg={{ span: 8, order: 0 }}
            md={{ span: 10, order: 0 }}
            sm={{ span: 12, order: 3 }}
            xl={{ span: 8, order: 0 }}
            xs={{ span: 24, order: 3 }}
          >
            <h3>{t('footer.serviceHotline')}</h3>
            <p>{parsedServiceInformation}</p>
          </Col>
          <Col
            className={styles.col_wrapper}
            lg={{ span: 7, order: 0 }}
            md={{ span: 6, order: 0 }}
            sm={{ span: 12, order: 5 }}
            xl={{ span: 7, order: 0 }}
            xs={{ span: 24, order: 5 }}
          >
            <img
              alt="SSL Secured"
              height={70}
              loading="lazy"
              src={SSLIcon}
              title="SSL Secured"
              width={51}
            />
          </Col>
          <Col
            className={styles.col_wrapper}
            lg={{ span: 7, offset: 2, order: 0 }}
            md={{ span: 8, offset: 0, order: 0 }}
            sm={12}
            xl={{ span: 7, offset: 2, order: 0 }}
            xs={24}
          >
            <h3>{t('footer.legal')}</h3>
            <p>
              <B2BecLink to="/general-terms-and-conditions">
                {t('footer.AGBKBusinessPortal')}
              </B2BecLink>
            </p>
            <p>
              <B2BecLink to="/imprint">{t('footer.imprint')}</B2BecLink>
            </p>
            <p>
              <B2BecLink to="/data-protection-policy">
                {t('footer.dataProtection')}
              </B2BecLink>
            </p>
          </Col>
          <Col
            className={styles.col_wrapper}
            lg={{ span: 15, order: 0 }}
            md={{ span: 16, order: 0 }}
            sm={{ span: 12, order: 4 }}
            xl={{ span: 15, order: 0 }}
            xs={{ span: 24, order: 4 }}
          >
            <h3>{t('footer.repairService')}</h3>
            <p>{parseHtml(t('footer.repairServiceContact'))}</p>
          </Col>
        </Row>
        <div
          className="full-width-page-component__wrapper"
          style={{ backgroundColor: '#fff' }}
        >
          <div className="container">
            <div className={styles.bottom__wrapper}>
              <h3>{t('footer.copyright', { currentYear })}</h3>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
